import { Helpers } from '../../helpers';
import { ITankBattery } from '../../interfaces/itank-battery';
import { Area } from '../area';
import { ArtificialLiftType } from '../artificial-lift-type';
import { Asset } from '../asset';
import { AssetTeam } from '../asset-team';
import { FuelGasContractStatus } from '../fuel-gas-contract-status';
import { OilContractStatus } from '../oil-contract-status';
import { OilTransportationType } from '../oil-transportation-type';
import { SaltWaterDisposalFacility } from '../salt-water-disposal-facility';
import { ScenarioWell } from '../scenario-well';
import { TankBatterySetupSize } from '../tank-battery-setup-size';
import { Well } from '../well';

export class TankBatteryBase {
  TankBatteryId: number;
  AssetId: number | null;
  AssetTeamId: number;
  Name: string | null;
  MaxOil: number | null;
  MaxGas: number | null;
  MaxWater: number | null;
  OilStorage: number | null;
  WaterStorage: number | null;
  EstWaterLineLength: number | null;
  EstGasLineLength: number | null;
  ArtificialLiftTypeId: number | null;
  Lat: number | null;
  Long: number | null;
  LatLongFinal: boolean;
  LatLongUpdateTStamp: Date | null;
  UpdateTStamp: Date | null;
  CompressorModel: string | null;
  Table29EmitSpec: string | null;
  UnitNumber: string | null;
  SerialNumber: string | null;
  PermitType: string | null;
  TCEQPermitNumber: number | null;
  LegacyAssetTeamId: number | null;
  FacilityExists: boolean | null;
  BatterySection: string | null;
  FacilityLeadTime: number | null;
  BatteryQuad: string | null;
  BatteryBlock: string | null;
  FlowLineLength: number | null;
  ElectricalActualTieInDate: Date | null;
  ElectricalScheduledTieInDate: Date | null;
  ElectricalSupplier: string | null;
  FuelGasActualTieInDate: Date | null;
  FuelGasContractStatusId: number | null;
  FuelGasEstVolume: number | null;
  FuelGasRequired: boolean | null;
  FuelGasScheduledTieInDate: Date | null;
  FuelGasSupplier: string | null;
  GasActualTieInDate: Date | null;
  GasComments: string | null;
  GasPurchaser: string | null;
  GasPurchaserNotifiedDate: Date | null;
  GasScheduledTieInDate: Date | null;
  OilActualTieInDate: Date | null;
  OilContractStatusId: number | null;
  OilPurchaser: string | null;
  OilScheduledTieInDate: Date | null;
  OilSurveyAndPlotProvidedDate: Date | null;
  OilTransportationTypeId: number | null;
  Location: object | null;
  TankBatterySetupSizeId: number | null;
  Cost: number | null;
  TankBatteryAreaId: number | null;
  Updated: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  UpdatedBy: string | null;
  WaterDispoalSystemAreaId: number | null;

  ScenarioWells_TankBattery?: Array<ScenarioWell> | null;
  Wells_TankBattery?: Array<Well> | null;
  SaltWaterDisposalFacilities_ParentTankBattery?: Array<SaltWaterDisposalFacility> | null;
  ArtificialLiftType?: ArtificialLiftType;
  Asset?: Asset;
  AssetTeam?: AssetTeam;
  FuelGasContractStatus?: FuelGasContractStatus;
  OilContractStatus?: OilContractStatus;
  OilTransportationType?: OilTransportationType;
  TankBatterySetupSize?: TankBatterySetupSize;
  LegacyAssetTeam?: AssetTeam;
  TankBatteryArea?: Area;
  WaterDispoalSystemArea?: Area;

  constructor(item?: ITankBattery) {
    if (item) {

      this.TankBatteryId = item.TankBatteryId;
      this.AssetId = item.AssetId;
      this.AssetTeamId = item.AssetTeamId;
      this.Name = item.Name;
      this.MaxOil = item.MaxOil;
      this.MaxGas = item.MaxGas;
      this.MaxWater = item.MaxWater;
      this.OilStorage = item.OilStorage;
      this.WaterStorage = item.WaterStorage;
      this.EstWaterLineLength = item.EstWaterLineLength;
      this.EstGasLineLength = item.EstGasLineLength;
      this.ArtificialLiftTypeId = item.ArtificialLiftTypeId;
      this.Lat = item.Lat;
      this.Long = item.Long;
      this.LatLongFinal = item.LatLongFinal;
      this.LatLongUpdateTStamp = item.LatLongUpdateTStamp ? new Date(item.LatLongUpdateTStamp) : null;
      this.UpdateTStamp = item.UpdateTStamp ? new Date(item.UpdateTStamp) : null;
      this.CompressorModel = item.CompressorModel;
      this.Table29EmitSpec = item.Table29EmitSpec;
      this.UnitNumber = item.UnitNumber;
      this.SerialNumber = item.SerialNumber;
      this.PermitType = item.PermitType;
      this.TCEQPermitNumber = item.TCEQPermitNumber;
      this.LegacyAssetTeamId = item.LegacyAssetTeamId;
      this.FacilityExists = item.FacilityExists;
      this.BatterySection = item.BatterySection;
      this.FacilityLeadTime = item.FacilityLeadTime;
      this.BatteryQuad = item.BatteryQuad;
      this.BatteryBlock = item.BatteryBlock;
      this.FlowLineLength = item.FlowLineLength;
      this.ElectricalActualTieInDate = item.ElectricalActualTieInDate ? new Date(item.ElectricalActualTieInDate) : null;
      this.ElectricalScheduledTieInDate = item.ElectricalScheduledTieInDate ? new Date(item.ElectricalScheduledTieInDate) : null;
      this.ElectricalSupplier = item.ElectricalSupplier;
      this.FuelGasActualTieInDate = item.FuelGasActualTieInDate ? new Date(item.FuelGasActualTieInDate) : null;
      this.FuelGasContractStatusId = item.FuelGasContractStatusId;
      this.FuelGasEstVolume = item.FuelGasEstVolume;
      this.FuelGasRequired = item.FuelGasRequired;
      this.FuelGasScheduledTieInDate = item.FuelGasScheduledTieInDate ? new Date(item.FuelGasScheduledTieInDate) : null;
      this.FuelGasSupplier = item.FuelGasSupplier;
      this.GasActualTieInDate = item.GasActualTieInDate ? new Date(item.GasActualTieInDate) : null;
      this.GasComments = item.GasComments;
      this.GasPurchaser = item.GasPurchaser;
      this.GasPurchaserNotifiedDate = item.GasPurchaserNotifiedDate ? new Date(item.GasPurchaserNotifiedDate) : null;
      this.GasScheduledTieInDate = item.GasScheduledTieInDate ? new Date(item.GasScheduledTieInDate) : null;
      this.OilActualTieInDate = item.OilActualTieInDate ? new Date(item.OilActualTieInDate) : null;
      this.OilContractStatusId = item.OilContractStatusId;
      this.OilPurchaser = item.OilPurchaser;
      this.OilScheduledTieInDate = item.OilScheduledTieInDate ? new Date(item.OilScheduledTieInDate) : null;
      this.OilSurveyAndPlotProvidedDate = item.OilSurveyAndPlotProvidedDate ? new Date(item.OilSurveyAndPlotProvidedDate) : null;
      this.OilTransportationTypeId = item.OilTransportationTypeId;
      this.Location = item.Location;
      this.TankBatterySetupSizeId = item.TankBatterySetupSizeId;
      this.Cost = item.Cost;
      this.TankBatteryAreaId = item.TankBatteryAreaId;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.UpdatedBy = item.UpdatedBy;
      this.WaterDispoalSystemAreaId = item.WaterDispoalSystemAreaId;

      this.ScenarioWells_TankBattery = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_TankBattery);
      this.Wells_TankBattery = Helpers.createClassArray(Well, item.Wells_TankBattery);
      this.SaltWaterDisposalFacilities_ParentTankBattery = Helpers.createClassArray(SaltWaterDisposalFacility, item.SaltWaterDisposalFacilities_ParentTankBattery);
      this.ArtificialLiftType = new ArtificialLiftType(item.ArtificialLiftType);
      this.Asset = new Asset(item.Asset);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.FuelGasContractStatus = new FuelGasContractStatus(item.FuelGasContractStatus);
      this.OilContractStatus = new OilContractStatus(item.OilContractStatus);
      this.OilTransportationType = new OilTransportationType(item.OilTransportationType);
      this.TankBatterySetupSize = new TankBatterySetupSize(item.TankBatterySetupSize);
      this.LegacyAssetTeam = new AssetTeam(item.LegacyAssetTeam);
      this.TankBatteryArea = new Area(item.TankBatteryArea);
      this.WaterDispoalSystemArea = new Area(item.WaterDispoalSystemArea);
    }
  }
}